module.exports = __webpack_public_path__ + "img/phone-car-with-map-screen.f8701681.png";